import type { ReportTrial } from '../../../api/playerReports'
const number = (n: number | null) =>
  n === null
    ? 'Sin dato'
    : n.toLocaleString('es-AR', { maximumFractionDigits: 1 })
export function TrialPhysiology({ trial: t }: { trial: ReportTrial }) {
  return (
    <div className="report-panel report-body-reading">
      <div className="report-body-pair" aria-label="Pulso durante el ciclo">
        <div>
          <span>Pico del ciclo</span>
          <strong>
            {number(t.hr_peak)} <small>lpm</small>
          </strong>
        </div>
        <span aria-hidden="true">→</span>
        <div>
          <span>Fin de recuperación</span>
          <strong>
            {number(t.hr_recovery)} <small>lpm</small>
          </strong>
        </div>
      </div>
      {t.hr_drop !== null && (
        <p className="report-muted">
          {number(Math.abs(t.hr_drop))} lpm de{' '}
          {t.hr_drop >= 0 ? 'descenso' : 'aumento'} entre ambos registros.
        </p>
      )}
      <p className="report-caption">
        Son dos mediciones del ciclo; no una curva continua. El cambio acompaña
        la acción y la pausa.
      </p>
      {t.rmssd !== null && (
        <div className="report-rmssd">
          <strong>Variabilidad entre latidos</strong>
          <p>
            RMSSD en recuperación: {number(t.rmssd)} ms
            {t.reference_rmssd !== null
              ? ` · Referencia inicial: ${number(t.reference_rmssd)} ms`
              : ''}
            .
          </p>
          <p className="report-caption">
            Complementa la lectura del pulso. La referencia inicial incluye
            práctica.
          </p>
        </div>
      )}
    </div>
  )
}
